// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  SCREEN: '[data-fragment="DeviceMove.screen"]'
};

export default class DeviceMove extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {
      readyToMove: false
    };
    this.handleMove = this.handleMove.bind(this);
  }

  didMount() {
    this.screen = this.element.querySelector(fragments.SCREEN);
    window.addEventListener('mousemove', this.handleMove);
    setInterval(() => {
      if (this.element.classList.contains('show')) {
        setTimeout(() => {
          this.setState({
            readyToMove: true
          });
        }, 1000);
      }
    }, 1000);
  }

  handleMove = (e) => {
    if (this.state.readyToMove && window.innerWidth >= 1200) {
      let xCenter = (e.clientX - (window.innerWidth / 2));
      let yCenter = (e.clientY - (window.innerHeight / 2));
      let x1 = xCenter * 0.005;
      let x2 = xCenter * -0.01;
      let y1 = yCenter * 0.005;
      let y2 = yCenter * -0.01;
      this.element.style.transform = `translate(${x1}px, ${y1}px) rotateY(${x1}deg)`;
      this.screen.style.transform = `translate(${x2}px, ${y2}px)`;
    }
  };

  willUnMount() {

  }
  update() {
    const { readyToMove } = this.state;
    classNames(this.element, { 'landing-try-it__device--mouse-move': readyToMove });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/DeviceMove.js